// ** MUI Imports
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Image from "next/image";

// ** Icon Imports
import Icon from "src/@core/components/icon";

// ** Components
import UserDropdown from "src/layouts/components/shared-components/UserDropdown";
import CartDropdown from "src/layouts/components/shared-components/CartDropdown";
import { Card, TextField, Typography } from "@mui/material";
import styled from "@emotion/styled";

import Link from "next/link";
import Navigation from "src/layouts/components/navigation/horizontal";
import { useAuth } from "src/hooks/useAuth";
import { useState } from "react";
import { convertProductCodeToMZ } from "src/utility/Utils";
import { useRouter } from "next/router";

const LogoIcon = styled("img")(({ theme }) => ({
  width: "100%",
}));

const SearchTextField = styled(TextField)(({ theme }) => ({
  flexGrow: 1,
  "& *": {
    border: "none !important",
    boxShadow: "none !important",
  },
}));

const AppBarContent = (props) => {
  const auth = useAuth();
  const router = useRouter();
  const [searchKey, setSearchKey] = useState("");

  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility, navItems } =
    props;

  const onSubmit = (e) => {
    // e.preventDefault()

    if (searchKey) {
      if (!searchKey.includes("amazon.ae")) {
        // toast.error('لینک محصول باید از آمازون امارات باشد')
        return;
      }
      const regex = /\/dp\/([A-Za-z0-9]+)\//;
      const match = searchKey.match(regex);
      if (!match) {
        return;
      }
      window.open(
        `${window.location.origin}/product/dp${convertProductCodeToMZ(
          match[0]
        )}`,
        "_blank"
      );
      // router.push(`/product/mz${convertProductCodeToMZ(match[0])}`,)
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        className="actions-left"
        sx={{ display: { xs: "block", lg: "none" } }}
      >
        <Button
          variant={"outlined"}
          color="secondary"
          aria-label="menu open button"
          sx={{ width: 45, height: 45, minWidth: 45, padding: 0 }}
          onClick={toggleNavVisibility}
        >
          <Icon color="black" fontSize="1.5rem" icon="tabler:menu-2" />
        </Button>
      </Box>

      <Box
        component={Link}
        href={"/"}
        className="actions-left"
        sx={{
          mr: 2,
          display: { xs: "none", lg: "flex" },
          alignItems: "center",
          gap: 2,
        }}
      >
        <Image
          src="/images/logo/logo2.svg"
          alt="logo img"
          width={20}
          height={20}
        />
        <Image
          src="/images/logo/logoBlack.svg"
          alt="logo img"
          width={70}
          height={40}
        />
      </Box>
      {hidden ? (
        <Image
          src="/images/logo/logoBlack.svg"
          alt="logo img"
          width={70}
          height={40}
        />
      ) : null}

      <Box sx={{ ml: 5, display: { xs: "none", lg: "block" } }}>
        <Navigation {...props} horizontalNavItems={navItems()} />
      </Box>

      {/* {router.pathname !== '/' && (
        <Card sx={{ display: { xs: 'none', lg: 'block' }, flex: 0.75, ml: 5, p: 1, borderRadius: 1 }}>
          <SearchForm>
            <SearchTextField
              size='small'
              fullWidth
              value={searchKey}
              onChange={v => setSearchKey(v.target.value)}
              placeholder='لینک محصول مورد نظر در آمازون امارات را وارد کنید ...'
            />
            <Button sx={{ width: 150, borderRadius: 2 }} variant='contained' size='medium' onClick={onSubmit}>
              جستجو
            </Button>
          </SearchForm>
        </Card>
      )} */}

      {hidden ? (
        <Button
          variant={"outlined"}
          color="secondary"
          sx={{ width: 45, height: 45, minWidth: 45, padding: 0 }}
        >
          <Image
            src="/images/logo/logo2.svg"
            alt="logo img"
            width={20}
            height={20}
          />
        </Button>
      ) : null}
      <Box
        className="actions-right"
        sx={{ display: { xs: "none", lg: "flex" }, alignItems: "center" }}
      >
        {auth.userData.token ? (
          <>
            <CartDropdown />
            <UserDropdown settings={settings} />
          </>
        ) : (
          <Link href="/login">
            <Button size="medium" variant="text" sx={{ mr: -3.5 }}>
              ورود / ثبت نام
            </Button>
          </Link>
        )}
      </Box>
    </Box>
  );
};

export default AppBarContent;
